import { Team, Player, Phase, Comment, Match } from './interfaces';
import Asset from 'src/requests/apa/Asset';
import EpgPersistence from 'src/AAF/Nepg/EpgPersistence';
import { getApaMatchUtcOffset } from '../utls/utils';
import { Dates } from 'packages/dates';

export function parseTeam(team: any): Team {
    return {
        id: team.id || "",
        name: (team.names && team.names.default) || "",
        nameAbbrev: (team.names && team.names.abbreviation) || "",
        flag: (team.nationality && team.nationality.images && team.nationality.images.flag) || "",
        logo: (team.images && team.images.teamLogo) || ""
    }
}

export function parsePlayer(player: any): Player {
    return {
        id: player.id || "",
        name: (player.names && player.names.default) || "",
        lastname: (player.names && player.names.last) || "",
        firstname: (player.names && player.names.first) || "",
        image: (player.images && player.images.playerHeadshotNational && resizePlayerImage(player.images.playerHeadshotNational)) || Asset.get('talent_player_placeholder_img', ""),
        nationality: (player.nationality && player.nationality.names && player.nationality.names.default) || "",
        nationalityAbbrev: (player.nationality && player.nationality.names && player.nationality.names.abbreviation) || "",
        role: player.properties && player.properties.role && player.properties.role.key,
        roleName: player.properties && player.properties.role && player.properties.role.names && player.properties.role.names.default,
        lineupStatus: player.properties && player.properties.lineupStatus && player.properties.lineupStatus.key,
        uniformNumber: player.properties && player.properties.uniformNumber,
        positionNumber: player.properties && player.properties.positionNumber,
        dateOfBirth: player.dateOfBirth ? player.dateOfBirth.split('-').reverse().join('/') : "",
        positionName: player.properties && player.properties.position && player.properties.position.names && player.properties.position.names.default
    }
}

function resizePlayerImage(image: string) {
    return image.replace("large", "600");
}


export function parsePhase(phase: any): Phase {
    return {
        id: phase.id || "",
        name: (phase.names && phase.names.default) || "",
        typeDetail: phase.typeDetail || "",
        timeFrom: (phase.dateAndTimeInfo && phase.dateAndTimeInfo.startDateLocal) || "",
        timeTo: (phase.dateAndTimeInfo && phase.dateAndTimeInfo.endDateLocal) || ""
    }
}

export function parseComment(comment: any): Comment {
    return {
        time: comment.state && comment.state.time && Number(comment.state.time.split(':')[0]),
        timeToDisplay: comment.state && comment.state.time,
        periodNumber: (comment.state && comment.state.periodNumber),
        type: comment.type,
        text: comment
            && comment.names
            && comment.names.default,
        subActions: comment.subActions
    }
}

export function parseMatch(match: any): Match {

    const homeTeam = parseTeam(match.homeParticipant || {});
    const awayTeam = parseTeam(match.awayParticipant || {});

    const dateAndTimeInfo = match.dateAndTimeInfo || {};
    const state = match.state || {};
    const status = match.status || {};

    return {
        id: match.id,
        homeTeam,
        awayTeam,
        date: dateAndTimeInfo.scheduledStartTimeUTC && changeDateToUserRegion(dateAndTimeInfo.scheduledStartTimeUTC),
        status: status.scheduleStatus,
        currentPeriod: state.currentPeriod,
        score: {
            awayScore: state.awayScore,
            homeScore: state.homeScore
        },
        groupId: getPhaseIdOfMatch(match, 'PHASE_GROUP'),
        roundId: getPhaseIdOfMatch(match, "PHASE_ROUND"),
        matchRoundId: getPhaseIdOfMatch(match, "PHASE_MATCHROUND"),
        stadium: match.venue && match.venue.names && match.venue.names.default
    }
}

function getPhaseIdOfMatch(match: any, phaseType: string) {
    const relatedSportEvents = (match && match.relatedSportsEvents) || [];
    const phase = relatedSportEvents.find((phase: any) => phase.typeDetail === phaseType) || {};
    return phase.id;
}

export function changeDateToUserRegion(ISODateString: string) {
    // starheader utc offset in minutes
    let startheaderUTC = EpgPersistence.getOffset();
    if(isNaN(startheaderUTC)) {
        startheaderUTC = 0;
    }
    startheaderUTC = startheaderUTC / 60;
    const dayAsString = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];
    const monthsAsNumber = [1,2,3,4,5,6,7,8,9,10,11,12];

    const apaMatchUTCOffset = getApaMatchUtcOffset();
    const currentDate = new Dates();
    const currentMontNumber = monthsAsNumber[currentDate.month()];
    const currentDayNumber = currentDate.day();
    const londonUTCOffset = currentMontNumber === 10 && currentDayNumber < 30 ? 1 : 0;

    // Get iso date date & time with substrings
    // 2021-06-22T00:00:00.000Z
    const isoday = ISODateString.substring(8,10);
    const isomonth = ISODateString.substring(5,7);
    const isoyear = ISODateString.substring(0,4);
    const isohour = ISODateString.substring(11,13);
    const isominute = ISODateString.substring(14,16);
    const isosecond = ISODateString.substring(17,19);
    const isodate = new Date(ISODateString);
    const isodayname = dayAsString[isodate.getDay()];

    // iso hour + utc + london utc (GMT-0 en invierno o "BST+1 british summer time" en verano)+ apa key
    const londonOffset = startheaderUTC < 0 ? (londonUTCOffset * -1) : londonUTCOffset;

    let hourDelta = Number(isohour) + Number(startheaderUTC) + Number(londonOffset) + Number(apaMatchUTCOffset);

    const isoData = {
        weekday: isodayname,
        year: isoyear,
        month: Number(isomonth),
        day: isoday,
        hours: hourDelta.toString().padStart(2, "0"),
        minutes:isominute,
        seconds: isosecond
    };

    return isoData;
}



// WEBPACK FOOTER //
// ./src/mundial/requests/utils.ts